import { call, put, takeLatest, select } from "redux-saga/effects"
import {
  FETCH_SECTIONS,
  FETCH_SECTION_TASKS,
  UPDATE_TASK_STATUS,
} from "./actionTypes"
import {
  fetchSectionsSuccess,
  fetchSectionsFail,
  fetchSectionTasksSuccess,
  fetchSectionTasksFail,
  updateTaskStatusSuccess,
  updateTaskStatusFail,
} from "./actions"
import { selectIsCacheValid, selectTasksCacheValid, selectSections, selectSectionTasks } from "./reducer"
import { getTypes, getTasks, patchTask } from "helpers/api_helper"

function* fetchSectionsSaga(action) {
  try {
    const { forceRefresh } = action.payload
    const cacheValid = yield select(selectIsCacheValid)

    if (cacheValid && !forceRefresh) {
      // Dispatch success with existing data to reset loading state
      const existingSections = yield select(selectSections)
      yield put(fetchSectionsSuccess(existingSections))
      return
    }

    const sections = yield call(getTypes)
    yield put(fetchSectionsSuccess(sections || []))
  } catch (error) {
    yield put(fetchSectionsFail(error.message))
  }
}

function* fetchSectionTasksSaga(action) {
  try {
    const { forceRefresh } = action.payload
    const cacheValid = yield select(selectTasksCacheValid)

    if (cacheValid && !forceRefresh) {
      // Dispatch success with existing data to reset loading state
      const existingTasks = yield select(selectSectionTasks)
      yield put(fetchSectionTasksSuccess(existingTasks))
      return
    }

    const tasks = yield call(getTasks)
    yield put(fetchSectionTasksSuccess(tasks || []))
  } catch (error) {
    yield put(fetchSectionTasksFail(error.message))
  }
}

function* updateTaskStatusSaga(action) {
  try {
    const { taskId, status, extraData } = action.payload
    const payload = {
      resource: [{ id: taskId, status, ...extraData }],
    }
    yield call(patchTask, payload)
    yield put(updateTaskStatusSuccess({ id: taskId, status, ...extraData }))
  } catch (error) {
    yield put(updateTaskStatusFail(error.message))
  }
}

function* sectionsSaga() {
  yield takeLatest(FETCH_SECTIONS, fetchSectionsSaga)
  yield takeLatest(FETCH_SECTION_TASKS, fetchSectionTasksSaga)
  yield takeLatest(UPDATE_TASK_STATUS, updateTaskStatusSaga)
}

export default sectionsSaga
